"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserRoles;
(function (UserRoles) {
    UserRoles["Producer"] = "Producer";
    UserRoles["Brand"] = "Brand";
    UserRoles["ActiveConsultant"] = "Active Consultant";
    UserRoles["Creator"] = "Creator";
    UserRoles["GeneralManager"] = "General Manager";
})(UserRoles = exports.UserRoles || (exports.UserRoles = {}));
//# sourceMappingURL=user-roles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-fns/dist/config/enums/user-roles.js
// module id = 1237
// module chunks = 0